// extracted by mini-css-extract-plugin
module.exports = {"LoaderSpinner":"Loader_LoaderSpinner__3aat2","lds-dual-ring":"Loader_lds-dual-ring__3mdFZ","center":"Loader_center__21lpZ"};